import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=4bdb760c&"
import script from "./SideMenu.vue?vue&type=script&lang=js&"
export * from "./SideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bdb760c')) {
      api.createRecord('4bdb760c', component.options)
    } else {
      api.reload('4bdb760c', component.options)
    }
    module.hot.accept("./SideMenu.vue?vue&type=template&id=4bdb760c&", function () {
      api.rerender('4bdb760c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/common/SideMenu.vue"
export default component.exports